import { render, staticRenderFns } from "./MainJournalTable.vue?vue&type=template&id=b54c2762"
import script from "./MainJournalTable.vue?vue&type=script&lang=js"
export * from "./MainJournalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports